module.exports = __webpack_public_path__ + "1a0379394c101af304b68e9ad37f188d.svg";